import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import {
  CustomerDeleteResponseModel,
  CustomerResponseModel,
  CustomerTypeResponseModel,
  LookupItemModel,
  ResponseBaseModel,
  SearchBeneficiaryRequestModel,
  SearchCustomerResponseModel,
} from "../models";
import { AlYuserApiUrls } from "../configuration";
import { handleError } from "../utils";
//#region get
export const getCurrentBalanceByCustomerId=async(customerId:number,accountId:number): Promise<number> => {
  try {
      let url: string = `${AlYuserApiUrls.customerController.getCurrentBalanceByCustomerId}?customerId=${customerId}&accountId=${accountId}`;
      const result: ResponseBaseModel<number> = await AlYusrAxiosApiInstance.get(url);
      return result?.Result||0;
  } catch (err) {
    alert(handleError(err));
  }
  return 0;
}
export const getAllCustomersForDropDown = async (): Promise<
  LookupItemModel[]
> => {
  let customerResult: ResponseBaseModel<CustomerResponseModel[]>;
  let response: LookupItemModel[] = [];
  customerResult = await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.customerController.getAllCustomers
  );
  if (
    customerResult !== null &&
    customerResult.Result !== null &&
    customerResult.Result !== undefined &&
    customerResult.Result.length !== 0
  ) {
    customerResult.Result.forEach((row) => {
      response.push({
        nameAr: row.Name,
        name: row.Name_En,
        value: row.ID.toString(),
      });
    });
  }
  return response;
};
export const searchCustomers = async (
  request: SearchBeneficiaryRequestModel
): Promise<ResponseBaseModel<SearchCustomerResponseModel[]>> => {
  let response: ResponseBaseModel<SearchCustomerResponseModel[]> = {};
  let url: string = `${AlYuserApiUrls.customerController.searchCustomer}?searchCustomer.lang=1`;
  url = `${url}&serachParmeter.pageSize=${request.pageSize || 10}`;
  url = `${url}&serachParmeter.custmertype=${request.type}`;
  url = `${url}&serachParmeter.pageNumber=${request.pageNumber || 1}`;
  url = request.searchValue
    ? `${url}&serachParmeter.name=${encodeURIComponent(request.searchValue)}`
    : url;
  const fetchResult: ResponseBaseModel<SearchCustomerResponseModel[]> =
    await AlYusrAxiosApiInstance.get(url);
  response.Errors = fetchResult.Errors;
  response.TotalRecoredCount = fetchResult.TotalRecoredCount;
  if (
    fetchResult.Result !== null &&
    fetchResult.Result !== undefined &&
    fetchResult.Result.length !== 0
  ) {
    response.Result = [];

    fetchResult.Result.forEach((row) => {
      // if(row.Cust_Type==2){
      response.Result?.push({
        ID: row.ID,
        City_ID: row.City_ID,
        Cust_Type: row.Cust_Type,
        CustomerType: row.CustomerType,
        Mail: row.Mail,
        MaxDebit: row.MaxDebit,
        Beg_AC_Bal: row.Beg_AC_Bal,
        Notes: row.Notes,
        address: row.address,
        Account_ID: row.Account_ID,
        TaxNumber: row.TaxNumber,
        Code: row.Code,
        Name: row.Name,
        Name_En: row.Name_En,
        Mobile: row.Mobile,
        Phone: row.Phone,
        Address: row.Address,
        IDNumber: row.IDNumber,
        BalanceOfPoint: row.BalanceOfPoint,
      });
      //}
    });
  }
  return response;
};
export const getCustomerInvoiceType = async (): Promise<LookupItemModel[]> => {
  try {
    const result: ResponseBaseModel<CustomerTypeResponseModel[]> =
      await AlYusrAxiosApiInstance.get(
        AlYuserApiUrls.customerController.getCustomerInvoiceType
      );
    // @ts-ignore
    let response: LookupItemModel[] = [];
    result.Result?.forEach((item) => {
      response.push({
        name: item.EnglishName,
        nameAr: item.ArabicName,
        value: item.Code,
      });
    });
    return response;
  } catch (err) {
    alert(handleError(err));
  }
  return [];
};

export const getCustomerById = async (
  id: number
): Promise<CustomerResponseModel> => {
  let url: string = `GetCustomerById?CustomerId=${id}`;
  const result: ResponseBaseModel<CustomerResponseModel> =
    await AlYusrAxiosApiInstance.get(url);
  // @ts-ignore
  return result !== null && result !== undefined ? result.Result : {};
};
//#endregion
//#region post
export const deleteCustomer = async (
  id: number
): Promise<ResponseBaseModel<CustomerDeleteResponseModel>> => {
  let apiResponse: ResponseBaseModel<CustomerDeleteResponseModel> = {};
  try {
    let url: string = `${AlYuserApiUrls.customerController.deleteCustomer}?id=${id}`;
    apiResponse = await AlYusrAxiosApiInstance.post(url);
    return apiResponse;
  } catch (err) {
    alert(handleError(err));
  }
  return apiResponse;
};
export const addCustomer = async (
  request: CustomerResponseModel
): Promise<ResponseBaseModel<CustomerResponseModel>> => {
  let apiResponse: ResponseBaseModel<CustomerResponseModel> = {};
  try {
    apiResponse = await AlYusrAxiosApiInstance.post(
      AlYuserApiUrls.customerController.saveCustomer,
      { ...request }
    );
    return apiResponse;
  } catch (err) {
    alert(handleError(err));
  }
  return apiResponse;
};
//#endregion
